var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 123.29 89.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f4ac24;}.cls-3{fill:#07053a;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#fff;opacity:0.2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 418.81,
    y1: 172.92,
    x2: 447.41,
    y2: 172.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c1cb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7118b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a90fb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff00c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fe15ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fa4d7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#f4a52a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4ac24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 446.61,
    y1: 250.92,
    x2: 446.61,
    y2: 177.53,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.41,181.34h-3.27v-1.73c0-6.43-4.95-11.66-11-11.66s-11,5.23-11,11.66v1.73h-3.27v-1.73c0-8.34,6.41-15.12,14.3-15.12s14.3,6.78,14.3,15.12Z",
    transform: "translate(-337.36 -164.49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.09,181.34h-3.27v-1.73c0-6.43-4.95-11.66-11-11.66s-11,5.23-11,11.66v1.73h-3.27v-1.73c0-8.34,6.42-15.12,14.31-15.12s14.3,6.78,14.3,15.12Z",
    transform: "translate(-337.36 -164.49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.09,209.85,370.9,253.79H337.36l59.17-72.57h35.76v72.61s-26.13-.56-28.07-26.34Z",
    transform: "translate(-337.36 -164.49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M460.57,181.22h-28v72.61s25.7-.16,28.07-26.32Z",
    transform: "translate(-337.36 -164.49)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M404.28,181.22h28v72.61s-25.7-.16-28.07-26.32Z",
    transform: "translate(-337.36 -164.49)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.ba00819ad70862f0369d329a7063c3aa.svg";
export { ForwardRef as ReactComponent };